import styled from 'styled-components';
import { Container } from '../../styles/chime-react/CommonStyles';
import { flexCenter } from '../../utils/style';
import Heading from '../chat/Heading';
import Label from '../chat/Label';
import { StyledCheckbox } from '../chat/Checkbox/Styled';

export const StyledRedText = styled.span`
  color: ${(props) => props.theme.colors.error.primary};
  font-weight: bold;
`;

export const StyledSectionTitle = styled(Heading)`
  font-size: 1.875rem;

  & {
    .small-text {
      margin-left: 0.5rem;
      font-size: ${(props) => props.theme.fontSizes.h4.fontSize};
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    font-size: 2.375rem;

    & {
      .small-text {
        margin-left: 1.25rem;
        font-size: ${(props) => props.theme.fontSizes.h2.fontSize};
      }
    }
  }
`;

export const StyledVideoWrap = styled.div`
  margin-top: 3.75rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  & {
    .video-title {
      font-size: ${(props) => props.theme.fontSizes.h3.fontSize};
      line-height: 1.5;
      text-align: center;
      font-weight: bold;
      margin-bottom: 1.25rem;

      &::before,
      &::after {
        content: '';
        display: inline-block;
        height: 2.25rem;
        width: 0.1875rem;
        border-radius: ${(props) => props.theme.radii.round};
        background-color: ${(props) => props.theme.colors.primary.main};
        margin-inline: 1.5rem;
        margin-bottom: -0.75rem;
      }

      &::before {
        transform: rotate(-25deg);
      }

      &::after {
        transform: rotate(25deg);
      }
    }

    .video-list {
      display: grid;
      grid-template-columns: 1fr;
      gap: 1.5rem;
    }

    .video-main {
      max-width: 100%;
      height: auto;
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    & {
      .video-list {
        grid-template-columns: 1fr 1fr;
        gap: 2.5rem;
        margin: 0 -1.25rem;
      }
    }
  }
`;

export const StyledTopSection = styled.section`
  position: relative;
  padding: 3.75rem 0 2.5rem;
  background-color: ${(props) => props.theme.globalStyle.bgd};
  background-size: auto auto;
  background-image: ${(props) => props.theme.globalStyle.stripedBgd};

  ${Container} {
    position: relative;
  }

  & {
    .img-free {
      position: absolute;
      top: 0;
      right: 0;
      width: 137px;
      height: 137px;
    }

    .service-name {
      display: inline-block;
      font-size: 1.375rem;
      text-align: center;
      position: relative;
      z-index: 2;
    }

    .introduction-text {
      margin-block: 0 0.75rem;
      font-size: ${(props) => props.theme.fontSizes.h6.fontSize};
      font-weight: ${(props) => props.theme.fontSizes.h6.fontWeight};
      line-height: 1.5;
      color: ${(props) => props.theme.colors.primary.main};
      position: relative;
      z-index: 2;
    }

    .img-wrap {
      width: 360px;
      height: 420px;
      position: absolute;
      top: -1.25rem;
      right: 1rem;
      z-index: 1;
      transform: scale(0.8);
      transform-origin: right;
      display: none;
    }

    .img-pc-man {
      position: absolute;
      top: 0;
      right: 0;
    }

    .img-mobile-woman {
      position: absolute;
      bottom: 0;
      left: 0;
    }

    .top-wrapper {
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
      text-align: center;
    }

    .top-wrap-image {
      margin-bottom: 1.25rem;
      max-width: 100%;
      height: auto;
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    & {
      .service-name {
        font-size: 2.5rem;
      }

      .introduction-text {
        font-size: ${(props) => props.theme.fontSizes.h4.fontSize};
        font-weight: ${(props) => props.theme.fontSizes.h4.fontWeight};
      }
    }
  }

  ${({ theme }) => theme.mediaQueries.min.lg} {
    padding: 7.5rem 0 8rem;

    & {
      .img-free {
        width: 232px;
        height: 232px;
      }

      .service-name {
        font-size: 3.125rem;
      }

      .introduction-text {
        margin-block: 2.5rem 0;
        font-size: ${(props) => props.theme.fontSizes.h2.fontSize};
        font-weight: ${(props) => props.theme.fontSizes.h2.fontWeight};
      }

      .top-wrapper {
        display: block;
        text-align: left;
      }

      .img-wrap {
        display: block;
      }

      .top-wrap-image {
        display: none;
      }
    }
  }

  ${({ theme }) => theme.mediaQueries.min.xl} {
    & {
      .img-wrap {
        transform: none;
        right: -5rem;
      }
    }
  }
`;

export const StyledDetailSection = styled.section`
  padding: 2.5rem 0;

  & {
    .detail-text {
      margin-top: 1.5rem;
      font-size: ${(props) => props.theme.fontSizes.h6.fontSize};
      line-height: 1.5;
    }

    .detail-img-wrap {
      margin-top: 3rem;
      ${flexCenter}

      img {
        max-width: 100%;
        height: auto;
      }
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    padding: 3.75rem 0;

    & {
      .detail-text {
        margin-top: 2.5rem;
        font-size: ${(props) => props.theme.fontSizes.h4.fontSize};

        &.align-center-pc {
          text-align: center;
        }
      }

      .detail-img-wrap {
        margin-top: 2.5rem;

        img {
          width: 100%;
        }
      }
    }
  }
`;

export const StyledUseSection = styled.section`
  padding: 1px 0 1.5rem;
  background-color: ${(props) => props.theme.globalStyle.bgd};
  background-size: auto auto;
  background-image: ${(props) => props.theme.globalStyle.stripedBgd};

  ${({ theme }) => theme.mediaQueries.min.md} {
    padding: 1.25rem 0 1.5rem;

    &.large-bottom {
      padding-bottom: 3.75rem;
    }
  }
`;

export const StyledUseBox = styled.div`
  margin-top: 2.5rem;
  position: relative;
  padding: 1.25rem;
  background-color: ${(props) => props.theme.colors.greys.white};
  border-radius: 1.25rem;

  &.align-left {
    text-align: left;
  }

  & {
    .img-free {
      position: absolute;
      top: 0;
      right: 0;
      width: 137px;
      height: 137px;
    }

    .description-wrap {
      margin-top: 1.25rem;
    }

    .description-text {
      display: grid;
      row-gap: 1rem;
      font-size: ${(props) => props.theme.fontSizes.h6.fontSize};
      line-height: 1.5;
    }

    .description-img {
      margin-top: 2.5rem;
      max-width: 100%;
      height: auto;
    }

    .description-large-image {
      margin-top: 2rem;
      text-align: center;

      img {
        max-width: 100%;
        height: auto;
      }
    }

    .app-wrap {
      margin-top: 1.5rem;
      position: relative;

      ${StyledVideoWrap} {
        margin-top: 1.5rem;
      }
    }

    .app-content {
      display: flex;
    }

    .app-icon-wrap {
      line-height: 1;
      text-align: center;
    }

    .app-icon-img {
      border-radius: 1.25rem;
      border: 1px solid ${(props) => props.theme.colors.greys.grey20};
    }

    .app-icon-text {
      margin-top: 0.75rem;
      font-size: 1.625rem;
      font-weight: bold;
    }

    .app-icon-small-text {
      margin-top: 0.5rem;
      font-size: ${(props) => props.theme.fontSizes.h4.fontSize};
      font-weight: bold;
    }

    .app-introduction-list {
      margin: 1rem 0 0 1.5rem;
    }

    .app-introduction {
      display: flex;
      align-items: center;
      margin-top: 1rem;

      & {
        .app-introduction-text {
          margin-left: 1rem;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          font-size: ${(props) => props.theme.fontSizes.h3.fontSize};
          font-weight: bold;
          line-height: 1.5;

          ${StyledRedText} {
            font-size: 1.875rem;
            margin-inline: 0.5rem;
          }
        }
      }
    }

    .app-man-img {
      position: absolute;
      bottom: -18px;
      right: 12px;
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    padding: 2.5rem 3.75rem;

    & {
      .img-free {
        width: 200px;
        height: 200px;
      }

      .description-wrap {
        margin-top: 1.5rem;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
      }

      .description-text {
        row-gap: 1.5rem;
        font-size: ${(props) => props.theme.fontSizes.h4.fontSize};
      }

      .description-img {
        margin-top: 0;
        max-width: 50%;
      }

      .description-large-image {
        margin: 3.75rem -1.25rem 0;
      }
    }
  }
`;

export const StyledUseBoxTitle = styled.h3`
  display: flex;
  flex-direction: column;
  padding-right: 3rem;
  font-size: 1.625rem;
  line-height: 1.5;
  font-weight: bold;
  color: ${(props) => props.theme.colors.primary.main};

  & {
    .box-order {
      font-size: 2.5rem;
    }

    .box-title {
      display: flex;
      align-items: baseline;
      flex-wrap: wrap;
      overflow-wrap: break-word;
    }

    .small-text {
      margin-inline: 0.5rem;
      font-size: ${(props) => props.theme.fontSizes.h4.fontSize};
    }

    &.small-space {
      .small-text {
        margin-inline: 0.25rem;
      }
    }

    &.no-padding {
      padding: 0;
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    flex-direction: row;
    align-items: center;
    font-size: ${(props) => props.theme.fontSizes.h1.fontSize};

    & {
      .box-order {
        font-size: 3.25rem;
        margin-right: 2rem;
      }

      .small-text {
        font-size: ${(props) => props.theme.fontSizes.h3.fontSize};
      }

      &.align-center-pc {
        justify-content: center;
      }
    }
  }
`;

export const StyledUsingSection = styled.section`
  position: relative;
  background-color: ${(props) => props.theme.colors.primary.main};
  padding: 3.75rem 0 5rem;
  text-align: center;

  & {
    .img-free {
      position: absolute;
      top: 0;
      right: 0;
    }

    ${StyledSectionTitle} {
      color: ${(props) => props.theme.colors.greys.white};
    }

    .using-small-note {
      margin-top: 1.5rem;
      font-size: ${(props) => props.theme.fontSizes.h6.fontSize};
      line-height: ${(props) => props.theme.fontSizes.h6.lineHeight};
      color: ${(props) => props.theme.colors.greys.white};
    }

    .using-note {
      margin-top: 3.75rem;
      font-size: ${(props) => props.theme.fontSizes.h4.fontSize};
      line-height: ${(props) => props.theme.fontSizes.h4.lineHeight};
      color: ${(props) => props.theme.colors.greys.white};
    }
  }
`;

export const StyledUsingButtonWrap = styled.div`
  margin-top: 2.5rem;
  ${flexCenter}

  & {
    a {
      text-decoration: none;
    }

    .using-button {
      font-size: ${(props) => props.theme.fontSizes.h3.fontSize};
      font-weight: 500;
      line-height: 1.33;
      background-color: ${(props) => props.theme.colors.greys.white};
      color: ${(props) => props.theme.colors.primary.main};
      border: none;
      border-radius: ${(props) => props.theme.radii.round};
      box-shadow: 0 4px 8px 0 #193c6b;
      padding: 1.5rem 2.5rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;

      &:hover {
        cursor: pointer;
        opacity: 0.7;
      }

      .normal-text {
        font-size: 1.625rem;
        font-weight: bold;
      }

      .large-text {
        margin-top: 0.75rem;
        font-size: 2.75rem;
        font-weight: bold;
      }

      .pointer-icon {
        position: absolute;
        right: 0.5rem;
        bottom: -3.125rem;
      }
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    & {
      .using-button {
        min-width: 28.5rem;

        .normal-text {
          font-size: 2.25rem;
        }

        .pointer-icon {
          right: 0;
          bottom: -1.5rem;
        }
      }
    }
  }
`;

export const StyledCredit = styled.p`
  margin-top: 1.5rem;
  text-align: right;
  font-size: ${(props) => props.theme.fontSizes.small.fontSize};
  line-height: ${(props) => props.theme.fontSizes.small.lineHeight};
`;

export const StyledFormBottomWrap = styled.div`
  display: grid;
  margin-top: 2.5rem;
  place-content: center;
  justify-items: center;

  & {
    .form-bottom-link {
      font-size: ${(props) => props.theme.fontSizes.h6.fontSize};
      line-height: ${(props) => props.theme.fontSizes.h6.lineHeight};
      margin: 1.25rem auto 2.5rem;
    }

    .submit-button {
      padding: 1rem 2.5rem;
      font-size: 1.5rem;
    }
  }
`;

export const StyledFromCheckboxLabel = styled(Label)`
  font-size: ${(props) => props.theme.fontSizes.h5.fontSize};
  line-height: ${(props) => props.theme.fontSizes.h5.lineHeight};

  ${StyledCheckbox} {
    margin-right: 1rem;
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const StyledTutorialFormWrap = styled.div`
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
  padding: 2rem 1.25rem;
  background-color: ${(props) => props.theme.colors.greys.white};
  border-radius: ${(props) => props.theme.radii.large};

  & {
    .form-note {
      font-size: ${(props) => props.theme.fontSizes.text.fontSize};
      line-height: ${(props) => props.theme.fontSizes.text.lineHeight};
      margin-block: 1.5rem;
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    margin-bottom: 0;
  }
`;

export const StyledNotice = styled.div`
  background-color: ${(props) => props.theme.colors.primary.main};
  padding: 0.75rem 1rem;
  font-size: ${(props) => props.theme.fontSizes.small.fontSize};
  line-height: ${(props) => props.theme.fontSizes.small.lineHeight};
  font-weight: bold;
  color: ${(props) => props.theme.colors.greys.white};
  display: flex;
  align-items: center;
  justify-content: center;

  & {
    .notice-icon {
      flex-shrink: 0;
      margin-right: 0.5rem;
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    padding: 1rem;
    font-size: ${(props) => props.theme.fontSizes.h4.fontSize};
    line-height: ${(props) => props.theme.fontSizes.h4.lineHeight};

    & {
      .notice-icon {
        margin-right: 1rem;
      }
    }
  }
`;

export const StyledFreeTrialTag = styled.div`
  background-color: ${(props) => props.theme.colors.error.primary};
  border-radius: ${(props) => props.theme.radii.round};
  padding: 0.25rem 1rem;
  font-size: ${(props) => props.theme.fontSizes.text.fontSize};
  line-height: ${(props) => props.theme.fontSizes.text.lineHeight};
  font-weight: bold;
  color: ${(props) => props.theme.colors.greys.white};
  white-space: nowrap;
  ${flexCenter}

  & {
    .inner-wrap {
      display: flex;
      align-items: baseline;
    }

    .small-text {
      font-size: ${(props) => props.theme.fontSizes.exSmall.fontSize};
      line-height: ${(props) => props.theme.fontSizes.exSmall.lineHeight};
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    padding: 0.5rem 2rem;
    font-size: ${(props) => props.theme.fontSizes.h4.fontSize};
    line-height: ${(props) => props.theme.fontSizes.h4.lineHeight};

    & {
      .small-text {
        font-size: ${(props) => props.theme.fontSizes.h6.fontSize};
        line-height: ${(props) => props.theme.fontSizes.h6.lineHeight};
      }
    }
  }
`;

export const StyledEstateCompanyTopSection = styled.section`
  position: relative;
  padding: 4.375rem 0 2.5rem;
  background-color: ${(props) => props.theme.globalStyle.bgd};
  background-size: auto auto;
  background-image: ${(props) => props.theme.globalStyle.stripedBgd};
  overflow: hidden;

  & {
    .img-free-trial {
      position: absolute;
      top: 0;
      right: 0;
      width: 171px;
      height: auto;
    }

    .top-wrapper {
      display: grid;
      grid-template:
        'topImgWrap' auto
        'serviceInfoWrap' auto/ auto;
    }

    .service-info-wrap {
      grid-area: serviceInfoWrap;
    }

    .service-name {
      font-size: 1.875rem;
      text-align: center;
    }

    .service-overview {
      margin-top: 1.5rem;
      font-size: ${(props) => props.theme.fontSizes.h6.fontSize};
      font-weight: bold;
      line-height: 1.5;
      color: ${(props) => props.theme.colors.primary.main};
    }

    .top-img-wrap {
      grid-area: topImgWrap;
      margin-bottom: 1.5rem;
      ${flexCenter}

      img {
        max-width: 100%;
        height: auto;
      }
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    padding: 5.625rem 0 1.5rem;

    & {
      .top-wrapper {
        grid-template: 'serviceInfoWrap topImgWrap' auto / minmax(500px, auto) minmax(
            150px,
            380px
          );
        column-gap: 0.25rem;
      }

      .service-name {
        margin-top: 1.25rem;
        font-size: 3.75rem;
        text-align: left;
      }

      .service-overview {
        margin-top: 2.5rem;
        font-size: 1.375rem;
        line-height: 1.5;
      }

      .top-img-wrap {
        margin-bottom: 0;

        img {
          width: 100%;
        }
      }
    }
  }

  ${({ theme }) => theme.mediaQueries.min.xl} {
    & {
      .img-free-trial {
        width: 274px;
      }

      .top-img-wrap {
        margin-right: -5.125rem;
      }
    }
  }
`;

export const StyledModalButtonWrap = styled.div`
  ${flexCenter}
  margin-top: 1.5rem;
`;
